import React from "react";
import "./styles.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
    this.handleCloseApp = this.handleCloseApp.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.toString() || "Неизвестная ошибка" };
  }

  componentDidCatch(error, errorInfo) {}

  handleCloseApp() {
    if (window.Telegram?.WebApp?.close) {
      window.Telegram.WebApp.close();
    } else {
      window.location.href = "/";
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-modal">
          <div className="error-boundary-content">
            <div className="error-boundary-title">Что-то пошло не так</div>
            <div className="error-boundary-text">
              {this.state.errorMessage}
              <br />
              Пожалуйста, перезапустите приложение или попробуйте позже.
            </div>
            <button className="error-boundary-btn" onClick={this.handleCloseApp}>
              Закрыть приложение
            </button>
            <div className="error-boundary-glow"></div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;







